import React from 'react';
import Joi from 'joi-browser';
import Form from '../../../common/form';

class Disable2faForm extends Form {
	state = {
		data: {
			token: '',
			securityPassword: '',
		},
		errors: {},
	};

	schema = {
		token: Joi.string()
			.length(6)
			.regex(/^[0-9]*$/, '"Only digits are allowed"')
			.required()
			.label('Verify Code'),
		securityPassword: Joi.string().required().label('Security Password'),
	};

	doSubmit = () => this.props.onSubmit(this.state.data);

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {
		const { isLoading, hasSP } = this.props;
		return (
			<form
				className='text-start'
				autoComplete='off'
				onSubmit={this.handleSubmit}>
				<div className='mb-3'>
					{this.renderInput({
						name: 'token',
						label: 'Enter the authentication code',
						type: 'text',
						formText:
							'For changing the setting, please verify the authentication code.',
					})}
				</div>
				{this.renderSubmitBtnWithSPass({
					divClass: 'mt-3',
					hasSP,
					isLoading,
					text: 'Disable 2FA',
					loadingText: 'Submitting...',
				})}
			</form>
		);
	}
}

export default Disable2faForm;
